/**
 * sorting.ts
 *
 * This utility module provides types and functions for sorting data based on defined priorities.
 *
 * See also:
 * - @../components/ec/engine/hooks/sorting/sortingUtils.ts - Additional sorting helpers.
 */

export enum SortingPriority {
  VERY_HIGH = 5,
  HIGH = 4,
  MEDIUM = 3,
  LOW = 2,
  VERY_LOW = 1,
}

/**
 * Compares two sorting priorities for descending order.
 *
 * @param a - The first sorting priority.
 * @param b - The second sorting priority.
 * @returns The numerical difference indicating sort order.
 */
export const sortByPriority = (a: SortingPriority, b: SortingPriority): number => b - a;
